<template>
    <modal name="order-information-cart-list-modal" class="item-modal dgm-modal"
           :width="'80%'"
           :height="'80%'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="lookbook_item_wrap" v-if="orderKey != 0">
            <div class="li_title">주문 목록</div>
            <button class="close_btn" @click="modalClose"></button>
            <order-modal-information-component :orderKey="orderKey" :modalName="'order-information-cart-list-modal'"></order-modal-information-component>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";
import OrderModalInformationComponent from "@/components/order/OrderModalInformationComponent.vue";

export default {
    name: "OrderInformationCartListModal",
    props: {},
    mixins: [],
    components: {
        OrderModalInformationComponent,
    },
    computed: {},
    provide() {
        return {
        }
    },
    data() {
        return {
            orderKey: 0,
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.orderKey)) {
                this.orderKey = event.params.orderKey;
            }
        },
        handlerOpened() {

        },
        handlerBeforeClose() {
            this.orderKey = 0;
            this.$router.replace(this.$route.path);
        },
        modalClose() {
            this.$modal.hide('order-information-cart-list-modal');
        },
    }
}
</script>

<style scoped>

</style>
